import React from 'react';
import clsx from 'clsx';
import {
    MenuItem,
    Menu,
    ClickAwayListener,
} from "@material-ui/core";

const DropdownMechanismNoLabel = (props) => {

    const {
        targets,
        selectTarget
    }=props;

    const [anchorEl, setAnchorEl] = React.useState(false);
    const [stateTarget, setStateTarget] = React.useState(false);

    //  This function opens the menu with the options of target pages.
    const changeTargetState = (event) => {
        setStateTarget(true);
        setAnchorEl(event.currentTarget);
    }

    //  This function closes the menu with the options of target pages.
    const closeMenuTarget = () => {
        setStateTarget(false);
        setAnchorEl(null)
    }


    return(
        <>  
            <span className ={clsx('teamSelector')} aria-hidden="true" onClick={(event) => changeTargetState(event)}>
                {stateTarget === false ? 
                    <i className={clsx('fa', 'fa-caret-down', 'fa-caret-down5','teamSelector')}/>
                    : 
                    <ClickAwayListener 
                        onClickAway ={closeMenuTarget}
                    >
                        <i className={clsx('fa', 'fa-caret-up','fa-caret-up5', 'teamSelector')} />
                    </ClickAwayListener>
                }  
            </span>
             
            <Menu   
                elevation={0}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                keepMounted
                open={stateTarget}
                >
                    {   targets !== undefined ?
                        targets.map((option) => (
                            <MenuItem 
                                key={option}
                                onClick ={() => selectTarget(option)}
                                > 
                                {option}
                            </MenuItem>
                        ))
                        : null
                    }
            </Menu>
        </>
    )

}

export default DropdownMechanismNoLabel;